import {useUsuarioStore} from '@stores'
import type {UsuarioDto} from '../types'

export function useGlobalUser(): readonly [UsuarioDto, (usuario: UsuarioDto) => void] {
    const usuario = useUsuarioStore(state => state.usuario)
    const definirUsuario = useUsuarioStore(state => state.definirUsuario)

    return [usuario, definirUsuario]
}
